















































































































import Vue from 'vue';
import AppAttribution from '../components/AppAttribution.vue';
import config from '../config';

export default Vue.extend({
  data() {
    return {
      appName: config.appName,
      openAttribution: false,
    };
  },
  methods: {
    onAttrLinkClick() {
      this.openAttribution = true;
    },
  },
  components: {
    AppAttribution,
  },
});
